import FullIndex from '@rebuild/materials/shared/widget_shell/FullIndex.vue';
import MobFull from '@rebuild/materials/shared/widget_shell/MobFull.vue';
import Overview from './base_overview.vue';
import MobOverview from './base_mob_overview.vue';

export const componentMap = {
	overview: Overview,
	full: FullIndex,
	'mob-overview': MobOverview,
	'mob-full': MobFull
};
